export default __webpack_public_path__ + "static/media/logo2-transparent.bc8110cf.png";